import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { signOut } from "firebase/auth";
import { auth } from '../firebase-config';
import './NavBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons';

function NavBar() {
  const { currentUser } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen); 
  };

  return (
    <nav className="navbar">
      <div className="nav-logo">
        <img src="../images/logo.png" alt="Logo Klubu" />
        <span className="club-name">Klub aktywnej turystyki pieszej "Aktywni Starachowice"</span>
      </div>
      <div className="nav-links">
        <Link to="/"><FontAwesomeIcon icon={faHome} /></Link>
        <button onClick={toggleMenu} className="menu-toggle">
          <FontAwesomeIcon icon={faBars} />
        </button>
        {isOpen && (
          <div className="dropdown-menu">
            {currentUser ? (
              <>
                <Link to="/profile" onClick={() => setIsOpen(false)}><FontAwesomeIcon icon={faUser} /> Mój profil</Link>
                <Link to="/" onClick={() => {handleLogout(); setIsOpen(false);}}><FontAwesomeIcon icon={faSignOutAlt} /> Wyloguj się</Link>
                <Link to="/about" onClick={() => setIsOpen(false)}>O nas.</Link>
                <Link to="/contact" onClick={() => setIsOpen(false)}>Kontakt</Link>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setIsOpen(false)}>Zaloguj się!</Link>
                <Link to="/about" onClick={() => setIsOpen(false)}>O nas</Link>
                <Link to="/contact" onClick={() => setIsOpen(false)}>Kontakt</Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default NavBar;
